module.exports = __webpack_public_path__ + "img/xinzhuang-1.7365a9b9.jpg";